import api from 'api';

export const loadConversionGroupsGrid = api('POST /api/conversion-groups/grid');

export const loadConversionGroupDetails = api(
  'GET /api/conversion-groups/:id/details'
);

export const markAsReadConcepts = api(
  'POST /api/conversion-groups/is-new/read'
);
